module.exports = __webpack_public_path__ + "static/img/02bg2en.e24538e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/03month/02bg2en.png
// module id = PF2J
// module chunks = 0